import { PageTemplate } from "@omni/types/enums/pageTemplate.enum";
import queryString from "query-string";

import { addRecentSearch } from "@/components/Search/SearchBar/RecentSearches/recentSearches.source";
import { useThunkDispatch } from "@/redux/dispatcher";
import { isValidQuery } from "@/redux/modules/value/search/helpers/search.helpers";
import { configureSearch } from "@/redux/modules/value/search/search.actions";
import * as ScrollPositionService from "@/services/scrollPosition.service";
import { blurActiveElement } from "@/utils/blur";
import { Config } from "@/utils/config.utils";
import { isPageTemplate } from "@/utils/pageTemplate.utils";
import { scrollToTop } from "@/utils/scroll";
import { INVALIDATE_ALL } from "@/utils/search/invalidation.utils";

const useSubmitAutocompleteSearchBox = (
    getRedirectUrl: () => string | undefined
) => {
    const dispatch = useThunkDispatch();

    const submit = (stateQuery: string) => {
        if (!isValidQuery(stateQuery)) return;

        const redirectUrl = getRedirectUrl();
        if (redirectUrl) {
            addRecentSearch({
                label: stateQuery,
                redirectUrl: redirectUrl
            });

            location.assign(redirectUrl);

            return;
        }

        const parsedUrl = queryString.parse(
            queryString.pick(location.search.replaceAll("+", "%20"), [
                "wcmmode"
            ]),
            { parseNumbers: true }
        );

        const query = queryString
            .stringify({ ...parsedUrl, q: stateQuery.replace(" ", "+") })
            .replace("%2B", "+");

        ScrollPositionService.pushPosition(
            window.scrollY,
            window.location.href
        );

        const href = `${Config.pages.search}?${query}`;

        blurActiveElement();
        ScrollPositionService.pushPosition(0, href);
        scrollToTop("auto");

        if (isPageTemplate(PageTemplate.Search)) {
            dispatch(
                configureSearch(
                    {
                        query: stateQuery
                    },
                    INVALIDATE_ALL
                )
            );
        } else {
            location.assign(href);
        }
    };

    return { submit };
};

export { useSubmitAutocompleteSearchBox };
